import { Component, Input, OnInit } from "@angular/core";
import { UserInfoService } from "./../services/user-info.service";
import { IUser } from "../models/user.model";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
} from "@angular/forms";
import { Subscription } from "rxjs";
import countries from "../../assets/data/countries.json";
import { ZpDataService } from "./../services/zp-data.service";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { CustomValidators } from "../custom-validators";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationService } from "../services/notification.service";
import { ZPNotification } from "../models/zpnotification";
import { DeviceDetectorService } from "ngx-device-detector";
import { ThemeService } from "../theme/theme-service.service";
import { Location } from "@angular/common";
import { PreviousUrlService } from "../services/previous-url.service";
import { ExcelService } from "../services/excel.service";

@Component({
  selector: "app-account-settings",
  templateUrl: "./account-settings.component.html",
  styleUrls: ["./account-settings.component.scss"],
  standalone: false,
})
export class AccountSettingsComponent implements OnInit {
  @Input() firstPara = "Are you sure you want to delete you Zenplans account?";
  @Input() scdPara =
    "If yes, please do not forget to export your data before deleting your account.";
  public deviceInfo = null;
  public statusMobileMenu: boolean;
  public chosenTab: string;
  public aboutMeFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public paymentFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public passwordFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public antiPhishingCodeFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public planUpdateFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public contactReferencesFormGroup: UntypedFormGroup = new UntypedFormGroup(
    {}
  );
  public itemOwnersFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public securityFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public editFormGroup: UntypedFormGroup = new UntypedFormGroup({});
  public subscription: Subscription;
  public subscription2: Subscription;
  public subscription3: Subscription;
  public subscription4: Promise<void>;
  public myUser: IUser;
  public myCountries = countries;
  public dataIsLoaded: boolean = false;
  public submitted = false;
  public mySharedPlans: {}[];
  public hasPlan: any;
  public showSideNav: string;
  public id: any;
  public section;
  public updateIsCheked: boolean;
  public reminderIsCheked: boolean;
  public message: string;
  public user = { clientId: "" };
  public refCode: any;
  public dataSponsor: any;
  public currentFile: any;
  public logoIsLoaded: boolean;
  public avatarUrl: any;
  public selectedMfaVia;
  public professionalProfession = [
    "Accountant",
    "IFA",
    "Solicitor",
    "Estate Planner",
  ];
  public statusPassword;
  public capsOn;
  public statusOldPassword;
  public planUpdates;
  public opt;
  public showModal = false;
  public isInvalid: boolean;
  public isAvatar: boolean;
  public hideBrokenImage: boolean = false;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public invalid: any;
  public country: any;
  public ownerFirstName: string;
  public ownerLastName: string;
  public showDialog = false;
  public itemToDeleteId;
  public itemNameforDialog;
  public displayOwnerForm: boolean;
  public jointOwnersList: IJointOwner[] = [];
  public currentOwner: IJointOwner = {
    first: " ",
    last: " ",
    relationship: " ",
  };
  public editCurrentOwner: boolean;
  public selectedOwner;
  public previousLink: string;
  public hideBackBtn: boolean;
  public ownerArrayWithItems: any = [];
  public itemCantBeDeleted: string;
  public mfaViaOptions = ["Mail", "SMS"];
  oldOwner: { first: string; last: string; relationship: any };
  smsError: boolean;
  displayItemsOwner: boolean;
  public doMFA = false;
  isMFAMobile: boolean;
  isMFAEmail: boolean;
  public MFAFail: boolean = false;
  showStep2MFA: boolean;
  showStep1Warning: boolean = true;
  showStep3Deletion: boolean;
  MFACode: string = "";
  resendCodeDisabled: boolean;
  public intervalId: ReturnType<typeof setTimeout>;
  counter: any = 60;
  logoutTimer: number = 10;
  logoutInterval: any;
  disabled: boolean;

  constructor(
    private userInfoService: UserInfoService,
    public zenplansDataService: ZpDataService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    public themeService: ThemeService,
    private deviceService: DeviceDetectorService,
    private location: Location,
    private previousUrl: PreviousUrlService,
    private excelMultiSheetService: ExcelService
  ) {
    // this.epicFunction();
  }

  async ngOnInit() {
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log(this.previousLink);
    if (
      this.previousLink == "/bank-account_joint-owners" ||
      this.previousLink == "/dynamicformdataentry/bank-account_joint-owners" ||
      this.previousLink.includes("/dynamicedit/bank-account-edit/")
    ) {
      this.hideBackBtn = false;
    } else {
      this.hideBackBtn = true;
    }
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    await this.getMyUser();
    this.mySharedPlans = await this.zenplansDataService.getSharedPlans(
      this.myUser
    );
    this.subscription = this.userInfoService.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      console.log(this.myUser);
      this.ownerFirstName = this.myUser.firstName;
      this.ownerLastName = this.myUser.lastName;
      if (this.myUser.userType == "professional") {
        this.showSideNav = "professional";
      } else if (this.myUser.userType == "admin") {
        this.showSideNav = "admin";
      } else if (this.myUser.userType == "planHolder") {
        this.showSideNav = "regular";
      } else {
        this.showSideNav = "regular";
      }
      if (this.myUser && this.myUser.jointOwners) {
        this.jointOwnersList = this.myUser.jointOwners;
      }
      // this.section = this.activatedRoute.snapshot.paramMap.get('section')
      // this.openTab(this.section)
      if (this.jointOwnersList.length === 0) {
        console.log(this.jointOwnersList);
        let defaultUserToSave = {
          first: this.myUser.firstName,
          last: this.myUser.lastName,
          relationship: this.myUser.relationship,
          default: true,
        };
        this.jointOwnersList.push(defaultUserToSave);
        console.log(this.jointOwnersList);
      }
    });

    // this.subscription2 = this.sideNavBarVisibilityService
    //   .getMessage()
    //   .subscribe(async (visibility) => {
    //     let myUser = this.zenplansDataService.getItemUser(this.id, "users");

    //   });

    this.subscription4 = this.zenplansDataService
      .getUser()
      .then(async (user) => {
        this.user = user;
        this.hasPlan = await this.zenplansDataService.getPlan(user["Id"]);
        console.log("getPlan(), -", this.hasPlan);
        if (this.hasPlan) {
          this.showSideNav = "bottom";
        } else if (
          !this.hasPlan &&
          this.mySharedPlans &&
          this.mySharedPlans.length > 0
        ) {
          this.showSideNav = "top";
        }
        if (
          this.mySharedPlans &&
          this.mySharedPlans.length > 0 &&
          this.myUser.userType
        ) {
          console.log("The user is a delegate but also has a plan.");
          this.displayItemsOwner = true;
        } else if (
          this.mySharedPlans &&
          this.mySharedPlans.length > 0 &&
          this.myUser.userType != "planHolder" &&
          this.myUser.userType != "professional"
        ) {
          console.log("The user is a pure delegate.");
          this.displayItemsOwner = false;
        } else {
          this.displayItemsOwner = true;
          console.log("The user is not a delegate at all.");
        }
        this.refCode = user.refCode;
        await this.zenplansDataService.setRefCode(this.refCode);
        this.dataSponsor = await this.zenplansDataService.retrieveValidRefCode(
          this.refCode
        );
      });
    if (this.myUser) {
      this.updateScreen(this.myUser.clientId);
    }
    this.antiPhishingCodeFormGroup.addControl(
      "Id",
      new UntypedFormControl(this.myUser.Id)
    );
    this.antiPhishingCodeFormGroup.addControl(
      "createAntiPhishingCode",
      new UntypedFormControl(
        this.myUser.createAntiPhishingCode
          ? this.myUser.createAntiPhishingCode
          : ""
      )
    );
    // Professional Manager
    if (this.myUser && this.myUser.userType == "professionalManager") {
      this.aboutMeFormGroup.addControl(
        "professionalAddress",
        new UntypedFormControl(
          this.myUser.professionalAddress,
          Validators.required
        )
      );
      this.securityFormGroup.addControl(
        "professionalProfession",
        new UntypedFormControl(
          this.myUser.professionalProfession
            ? this.myUser.professionalProfession
            : ""
        )
      );
    }

    // Professional Manager || Professional
    this.aboutMeFormGroup.addControl(
      "Id",
      new UntypedFormControl(this.myUser.Id)
    );
    if (
      (this.myUser && this.myUser.userType == "professional") ||
      (this.myUser && this.myUser.userType == "professionalManager")
    ) {
      this.aboutMeFormGroup.addControl(
        "company",
        new UntypedFormControl(this.myUser.company, Validators.required)
      );
    }

    // Different than Profeesional && Professional Manager
    if (
      (this.myUser && this.myUser.userType != "professional") ||
      (this.myUser && this.myUser.userType != "professionalManager")
    ) {
      this.aboutMeFormGroup.addControl(
        "dateOfBirth",
        new UntypedFormControl(this.myUser.dateOfBirth)
      );
      this.aboutMeFormGroup.addControl(
        "country",
        new UntypedFormControl(this.myUser.country ? this.myUser.country : "")
      );
      this.planUpdateFormGroup.addControl(
        "planUpdateReminder",
        new UntypedFormControl(
          this.myUser.planUpdateReminder ? this.myUser.planUpdateReminder : ""
        )
      );
      this.contactReferencesFormGroup.addControl(
        "sendPlanUpdateReminders",
        new UntypedFormControl(
          this.myUser.sendPlanUpdateReminders
            ? this.myUser.sendPlanUpdateReminders
            : false
        )
      );
    }

    // Different than Professional
    if (this.myUser && this.myUser.userType != "professional") {
      this.aboutMeFormGroup.addControl(
        "postCode",
        new UntypedFormControl(this.myUser.postCode)
      );
      this.paymentFormGroup.addControl(
        "Id",
        new UntypedFormControl(this.myUser.Id)
      );
      this.paymentFormGroup.addControl(
        "ccHolder",
        new UntypedFormControl(
          this.myUser.ccHolder ? this.myUser.ccHolder : "",
          Validators.required
        )
      );
      this.paymentFormGroup.addControl(
        "ccNumber",
        new UntypedFormControl(
          this.myUser.ccNumber ? this.myUser.ccNumber : "",
          Validators.required
        )
      );
      this.paymentFormGroup.addControl(
        "ccExpire",
        new UntypedFormControl(
          this.myUser.ccExpire ? this.myUser.ccExpire : "",
          Validators.required
        )
      );
    }

    this.aboutMeFormGroup.addControl(
      "lastName",
      new UntypedFormControl(this.myUser.lastName, Validators.required)
    );
    this.aboutMeFormGroup.addControl(
      "firstName",
      new UntypedFormControl(this.myUser.firstName, Validators.required)
    );
    this.passwordFormGroup.addControl(
      "Id",
      new UntypedFormControl(this.myUser.Id)
    );
    this.aboutMeFormGroup.addControl(
      "phoneNumber",
      new UntypedFormControl(this.myUser.phoneNumber)
    );
    this.passwordFormGroup.addControl(
      "password",
      new UntypedFormControl("", [Validators.required, Validators.minLength(6)])
    );
    this.passwordFormGroup.addControl(
      "oldPassword",
      new UntypedFormControl("", Validators.required)
    );
    this.securityFormGroup.addControl(
      "mfaAlways",
      new UntypedFormControl(this.myUser.mfaAlways ? this.myUser.mfaAlways : "")
    );
    this.securityFormGroup.addControl(
      "mfaVia",
      new UntypedFormControl(this.myUser.mfaVia ? this.myUser.mfaVia : "")
    );
    this.planUpdateFormGroup.addControl(
      "Id",
      new UntypedFormControl(this.myUser.Id)
    );
    this.contactReferencesFormGroup.addControl(
      "Id",
      new UntypedFormControl(this.myUser.Id)
    );
    this.contactReferencesFormGroup.addControl(
      "offersAuthorization",
      new UntypedFormControl(
        this.myUser.offersAuthorization
          ? this.myUser.offersAuthorization
          : false
      )
    );
    this.itemOwnersFormGroup.addControl(
      "first",
      new UntypedFormControl(
        this.currentOwner.first ? this.currentOwner.first : false
      )
    );
    this.itemOwnersFormGroup.addControl(
      "last",
      new UntypedFormControl(
        this.currentOwner.last ? this.currentOwner.last : false
      )
    );
    this.itemOwnersFormGroup.addControl(
      "relationship",
      new UntypedFormControl(
        this.currentOwner.relationship ? this.currentOwner.relationship : false
      )
    );

    this.dataIsLoaded = true;
    let self = this;
    window.setTimeout(function () {
      self.subscription3 = self.activatedRoute.url.subscribe((url) => {
        self.section = self.activatedRoute.snapshot.paramMap.get("section");
        self.openTab(self.section);
      });
    });
  }

  backToPlan() {
    this.location.back();
  }

  add() {
    this.displayOwnerForm = true;
    console.log(this.currentOwner);
    if (this.currentOwner !== null) {
      this.currentOwner.first = " ";
      this.currentOwner.last = " ";
      this.currentOwner.relationship = " ";
      console.log("currentOwner - ", this.currentOwner);
    }
    // this.itemOwnersFormGroup.reset();
  }

  back() {
    this.displayOwnerForm = false;
  }

  async addNewOwner() {
    this.itemOwnersFormGroup.value.first =
      this.itemOwnersFormGroup.value.first.trim();
    this.itemOwnersFormGroup.value.last =
      this.itemOwnersFormGroup.value.last.trim();
    this.itemOwnersFormGroup.value.relationship =
      this.itemOwnersFormGroup.value.relationship.trim();
    console.log("itemOwnersFormGroup.value - ", this.itemOwnersFormGroup.value);
    let formValue = this.itemOwnersFormGroup.value;
    let formValueArray = Object.values(formValue);
    console.log("formValueArray - ", formValueArray);
    for (let i = 0; i < formValueArray.length; i++) {
      let element = formValueArray[i];
      if (element == "" || element == " ") {
        console.log("Empty value.");
        this.notificationService.changeMessage(
          new ZPNotification(
            "Error.",
            undefined,
            undefined,
            "All the fields have to be filled."
          )
        );
        window.scrollTo(0, 0);
        return false;
      }
    }
    this.jointOwnersList.push(this.itemOwnersFormGroup.value);
    console.log("jointOwnerList - ", this.jointOwnersList);
    this.displayOwnerForm = false;
    const userToSave = {
      Id: this.myUser.Id,
      lastUpdate: new Date(),
      lastUpdateBy: this.myUser.Id,
      jointOwners: this.jointOwnersList,
    };
    await this.zenplansDataService.updateUser(userToSave);
    this.ngOnInit();
  }

  async editOwner(idx) {
    this.currentOwner = this.jointOwnersList[idx];
    this.oldOwner = { ...this.currentOwner };
    this.editCurrentOwner = true;
    if (this.selectedOwner == idx) {
      this.selectedOwner = null;
    } else {
      this.selectedOwner = idx;
    }
  }

  backFromEditOwner() {
    this.editCurrentOwner = false;
    this.selectedOwner = null;
  }

  async saveOwner(owner, idx) {
    this.currentOwner = this.jointOwnersList[idx];
    this.currentOwner.first = this.itemOwnersFormGroup.value["first"];
    this.currentOwner.last = this.itemOwnersFormGroup.value["last"];
    this.currentOwner.relationship =
      this.itemOwnersFormGroup.value["relationship"];
    this.ownerArrayWithItems = this.zenplansDataService.updateItemsOwnerName(
      this.hasPlan,
      this.currentOwner,
      this.oldOwner
    );
    if (this.ownerArrayWithItems.length) {
      console.log("this.ownerArrayWithItems - ", this.ownerArrayWithItems);
    }
    this.editCurrentOwner = false;
    let userToSave = {
      Id: this.myUser.Id,
      lastUpdate: new Date(),
      lastUpdateBy: this.myUser.Id,
      jointOwners: this.jointOwnersList,
    };
    await this.zenplansDataService.updateUser(userToSave);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async deleteOwner(idx, owner) {
    this.ownerArrayWithItems = this.zenplansDataService.findItemsOwnedByOwner(
      this.hasPlan,
      owner
    );
    if (this.ownerArrayWithItems.length) {
      console.log("can't be deleted");
      this.itemCantBeDeleted = this.ownerArrayWithItems.join(" ,");
      this.notificationService.changeMessage(
        new ZPNotification(
          "Request Accepted.",
          undefined,
          undefined,
          `This owner can't be deleted because he still is listed as owning the following item(s): ${this.itemCantBeDeleted} in the plan.`
        )
      );
    } else {
      console.log("deleted");
      this.myUser.jointOwners = this.jointOwnersList.splice(idx, 1);
      const userToSave = {
        Id: this.myUser.Id,
        lastUpdate: new Date(),
        lastUpdateBy: this.myUser.Id,
        jointOwners: this.jointOwnersList,
      };
      await this.zenplansDataService.updateUser(userToSave);
      this.ngOnInit();
    }
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();
    const isDesktopDevice = this.deviceService.isDesktop();
  }

  get device(): any {
    return this.deviceService.getDeviceInfo();
  }

  get isMobile(): boolean {
    return this.deviceService.isMobile();
  }

  get isTablet(): boolean {
    return this.deviceService.isTablet();
  }

  get isDesktop(): boolean {
    return this.deviceService.isDesktop();
  }

  async updateScreen(clientId?) {
    this.avatarUrl = await this.zenplansDataService.getAvatar(clientId);
    console.log("avatarUrl - ", this.avatarUrl);
  }

  hideErrorImage() {
    setTimeout(() => {
      this.hideBrokenImage = true;
    }, 1000);
  }

  async getMyUser() {
    if (!this.myUser) {
      await this.zenplansDataService.getUser();
    }
  }

  openTab(tabName) {
    this.dataIsLoaded = true;
    //this.dataIsLoaded = false;
    this.chosenTab = tabName;
    let i: any, tabcontent: any;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    document.getElementById(tabName).style.display = "flex";
    if (this.statusMobileMenu) {
      this.statusMobileMenu = false;
    }
    switch (tabName) {
      case "aboutMe":
        this.aboutMeFormGroup = new UntypedFormGroup({});

        this.aboutMeFormGroup.addControl(
          "Id",
          new UntypedFormControl(this.myUser.Id)
        );

        // Professional || Professional Manager
        if (
          this.myUser &&
          (this.myUser.userType == "professional" ||
            this.myUser.userType == "professionalManager")
        ) {
          this.aboutMeFormGroup.addControl(
            "company",
            new UntypedFormControl(this.myUser.company, Validators.required)
          );
        }

        // Professional Manager
        if (this.myUser && this.myUser.userType == "professionalManager") {
          this.aboutMeFormGroup.addControl(
            "professionalAddress",
            new UntypedFormControl(
              this.myUser.professionalAddress,
              Validators.required
            )
          );
          //this.securityFormGroup.addControl("professionalProfession", new FormControl(this.myUser.professionalProfession ? this.myUser.professionalProfession : ""));
        }

        // Different than Professional && Professioanl Manager
        if (
          this.myUser &&
          this.myUser.userType != "professional" &&
          this.myUser.userType != "professionalManager"
        ) {
          this.aboutMeFormGroup.addControl(
            "dateOfBirth",
            new UntypedFormControl(this.myUser.dateOfBirth)
          );
          this.aboutMeFormGroup.addControl(
            "country",
            new UntypedFormControl(
              this.myUser.country ? this.myUser.country : ""
            )
          );
        }

        // Different than Professional
        if (this.myUser && this.myUser.userType != "professional") {
          this.aboutMeFormGroup.addControl(
            "postCode",
            new UntypedFormControl(this.myUser.postCode)
          );
        }

        this.aboutMeFormGroup.addControl(
          "phoneNumber",
          new UntypedFormControl(this.myUser.phoneNumber)
        );
        this.aboutMeFormGroup.addControl(
          "lastName",
          new UntypedFormControl(this.myUser.lastName, Validators.required)
        );
        this.aboutMeFormGroup.addControl(
          "firstName",
          new UntypedFormControl(this.myUser.firstName, Validators.required)
        );

        break;
      case "payment":
        this.paymentFormGroup = new UntypedFormGroup({});
        this.paymentFormGroup.addControl(
          "Id",
          new UntypedFormControl(this.myUser.Id)
        );
        this.paymentFormGroup.addControl(
          "ccHolder",
          new UntypedFormControl(this.myUser.ccHolder, Validators.required)
        );
        this.paymentFormGroup.addControl(
          "ccNumber",
          new UntypedFormControl(this.myUser.ccNumber, Validators.required)
        );
        this.paymentFormGroup.addControl(
          "ccExpire",
          new UntypedFormControl(this.myUser.ccExpire, Validators.required)
        );
        break;
      case "password":
        this.passwordFormGroup = new UntypedFormGroup({});

        this.passwordFormGroup.addControl(
          "Id",
          new UntypedFormControl(this.myUser.Id)
        );
        this.passwordFormGroup.addControl(
          "password",
          new UntypedFormControl("", [
            Validators.compose([
              Validators.required,
              // check whether the entered password has a number
              CustomValidators.patternValidator(/\d/, {
                hasNumber: true,
              }),
              CustomValidators.patternValidator(/[!@#$%^&*(),.?":{}|<>]/, {
                hasSpecialSymbol: true,
              }),
              // check whether the entered password has upper case letter
              CustomValidators.patternValidator(/[A-Z]/, {
                hasCapitalCase: true,
              }),
              // check whether the entered password has a lower case letter
              CustomValidators.patternValidator(/[a-z]/, {
                hasSmallCase: true,
              }),
              Validators.minLength(10),
            ]),
          ])
        );
        this.passwordFormGroup.addControl(
          "oldPassword",
          new UntypedFormControl("", Validators.required)
        );
        break;
      case "antiPhisingCode":
        this.antiPhishingCodeFormGroup = new UntypedFormGroup({});
        this.antiPhishingCodeFormGroup.addControl(
          "Id",
          new UntypedFormControl(this.myUser.Id)
        );
        this.antiPhishingCodeFormGroup.addControl(
          "createAntiPhishingCode",
          new UntypedFormControl(
            this.myUser.createAntiPhishingCode
              ? this.myUser.createAntiPhishingCode
              : ""
          )
        );
        break;
      case "planUpdates":
        this.planUpdateFormGroup = new UntypedFormGroup({});
        this.planUpdateFormGroup.addControl(
          "Id",
          new UntypedFormControl(this.myUser.Id)
        );
        // Different than Professional && Professioanl Manager
        if (
          (this.myUser && this.myUser.userType != "professional") ||
          (this.myUser && this.myUser.userType != "professionalManager")
        ) {
          this.planUpdateFormGroup.addControl(
            "planUpdateReminder",
            new UntypedFormControl(
              this.myUser.planUpdateReminder
                ? this.myUser.planUpdateReminder
                : ""
            )
          );
        }
        break;

      case "security":
        this.securityFormGroup = new UntypedFormGroup({});
        this.securityFormGroup.addControl(
          "Id",
          new UntypedFormControl(this.myUser.Id)
        );
        this.securityFormGroup.addControl(
          "mfaAlways",
          new UntypedFormControl(
            this.myUser.mfaAlways ? this.myUser.mfaAlways : ""
          )
        );
        this.securityFormGroup.addControl(
          "mfaVia",
          new UntypedFormControl(this.myUser.mfaVia ? this.myUser.mfaVia : "")
        );
        break;

      case "itemOwners":
        this.itemOwnersFormGroup = new UntypedFormGroup({});

        this.itemOwnersFormGroup.addControl(
          "first",
          new UntypedFormControl(
            this.currentOwner.first ? this.currentOwner.first : false
          )
        );
        this.itemOwnersFormGroup.addControl(
          "last",
          new UntypedFormControl(
            this.currentOwner.last ? this.currentOwner.last : false
          )
        );
        this.itemOwnersFormGroup.addControl(
          "relationship",
          new UntypedFormControl(
            this.currentOwner.relationship
              ? this.currentOwner.relationship
              : false
          )
        );

        break;

      case "contactReferences":
        this.contactReferencesFormGroup = new UntypedFormGroup({});
        this.contactReferencesFormGroup.addControl(
          "Id",
          new UntypedFormControl(this.myUser.Id)
        );
        this.contactReferencesFormGroup.addControl(
          "offersAuthorization",
          new UntypedFormControl(
            this.myUser.offersAuthorization
              ? this.myUser.offersAuthorization
              : false
          )
        );
        // Different than Professional && Professioanl Manager
        if (
          (this.myUser && this.myUser.userType != "professional") ||
          (this.myUser && this.myUser.userType != "professionalManager")
        ) {
          this.contactReferencesFormGroup.addControl(
            "sendPlanUpdateReminders",
            new UntypedFormControl(
              this.myUser.sendPlanUpdateReminders
                ? this.myUser.sendPlanUpdateReminders
                : false
            )
          );
        }
        break;

      case "cancelZenplans":
        console.log("cancelZenplans");
    }
  }

  async exportData() {
    await this.zenplansDataService.getUserDataToExport();
    // try {

    //   // Assuming you injected ExcelService as excelExportSvc
    //   this.excelMultiSheetService.exportNestedJsonToExcel(
    //     data,
    //     "zenplans_user_data"
    //   );
    // } catch (error) {
    //   console.error("Export failed", error);
    // }
  }

  async saveAboutMe() {
    this.submitted = true;
    if (this.aboutMeFormGroup.invalid) {
      return;
    }
    this.aboutMeFormGroup.value["lastUpdate"] = new Date();
    this.aboutMeFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.aboutMeFormGroup.value);
    await this.zenplansDataService.updateUser(this.aboutMeFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async savePayment() {
    this.paymentFormGroup.value["lastUpdate"] = new Date();
    this.paymentFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.paymentFormGroup.value);
    await this.zenplansDataService.updateUser(this.paymentFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async savePassword() {
    this.submitted = true;
    if (this.passwordFormGroup.invalid) {
      this.isInvalid = true;
      return;
    }
    this.passwordFormGroup.value["lastUpdate"] = new Date();
    this.passwordFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.passwordFormGroup.value);
    await this.zenplansDataService.updateUser(this.passwordFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async createAntiPhishingCode() {
    this.antiPhishingCodeFormGroup.value["lastUpdate"] = new Date();
    this.antiPhishingCodeFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.antiPhishingCodeFormGroup.value);
    await this.zenplansDataService.updateUser(
      this.antiPhishingCodeFormGroup.value
    );
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async saveContactReferences() {
    this.contactReferencesFormGroup.value["lastUpdate"] = new Date();
    this.contactReferencesFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.contactReferencesFormGroup.value);
    await this.zenplansDataService.updateUser(
      this.contactReferencesFormGroup.value
    );
    window.scrollTo(0, 0);
    this.ngOnInit();
  }

  async savePlanUpdate() {
    let value = this.planUpdateFormGroup.value.planUpdateReminder;
    switch (value) {
      case "Every 3 Months":
        this.planUpdateFormGroup.value["planUpdateReminder"] = "90";
        break;
      case "Every 6 Months":
        this.planUpdateFormGroup.value["planUpdateReminder"] = "180";
        break;
      case "Once a Year":
        this.planUpdateFormGroup.value["planUpdateReminder"] = "365";
        break;
    }
    this.planUpdateFormGroup.value["lastUpdate"] = new Date();
    this.planUpdateFormGroup.value["lastUpdateBy"] = this.myUser.Id;
    let pp = JSON.stringify(this.planUpdateFormGroup.value);
    await this.zenplansDataService.updateUser(this.planUpdateFormGroup.value);
    window.scrollTo(0, 0);
    this.ngOnInit();
    this.router.navigate(["/home"]);
  }

  async saveSecurity(mfaViaChoice) {
    console.log("mfaViaChoice: ", mfaViaChoice);
    if (mfaViaChoice === "SMS" && !this.myUser.phoneNumber) {
      this.smsError = true;
    } else {
      this.smsError = false;
      this.securityFormGroup.value["lastUpdate"] = new Date();
      this.securityFormGroup.value["lastUpdateBy"] = this.myUser.Id;
      let pp = JSON.stringify(this.securityFormGroup.value);
      await this.zenplansDataService.updateUser(this.securityFormGroup.value);
      window.scrollTo(0, 0);
      this.ngOnInit();
    }
  }

  onChangeMfaVia(mfaViaChoice) {
    if (mfaViaChoice === "Email") {
      this.smsError = false;
    }
  }

  showModalDeleteUser() {
    this.showModal = true;
  }

  async deleteUserAccount(choice) {
    if (choice === "Yes") {
      if (!this.doMFA) {
        // await this.zenplansDataService.requestMFACode();
        this.doMFA = true;
        if (this.myUser && this.myUser.mfaVia && this.myUser.mfaVia == "SMS") {
          this.isMFAMobile = true;
        }
        if (
          this.myUser &&
          this.myUser.mfaVia &&
          this.myUser.mfaVia == "Email"
        ) {
          this.isMFAEmail = true;
        }
      }
      // let data = await this.zenplansDataService.deleteUserAccount();
      // if (data.success) {
      //   this.showModal = false;
      //   this.notificationService.changeMessage(
      //     new ZPNotification(
      //       "Request Accepted.",
      //       undefined,
      //       undefined,
      //       "You will be disconnected in a few seconds and your account will be deleted."
      //     )
      //   );
      //   setTimeout(() => {
      //     this.zenplansDataService.logout();
      //   }, 5000);
      // }
    } else {
      this.showModal = false;
    }
  }

  async onSubmit() {
    this.submitted = true;
    console.log("checkMfaBeforeDeleting");
  }

  async stepToDeleteAccountMFA() {
    this.showStep2MFA = true;
    this.showStep1Warning = false;
    await this.zenplansDataService.requestMFACode();
    this.disabled = true;
  }

  get isSMS() {
    console.log(this.myUser);
    if (this.myUser && this.myUser.mfaVia && this.myUser.mfaVia === "SMS") {
      return true;
    }
    return false;
  }

  async confirmMFACode(mfaCode) {
    console.log("confirmCode() myUser: ", this.myUser);
    let code = mfaCode;
    if (code) {
      const result = await this.zenplansDataService.confirmMFACode(code);
      if (result.success) {
        console.log("result ", result);
        return true;
      } else {
        this.MFAFail = true;
        console.error("MFA confirmation failed: ", result.message);
        return false;
      }
    } else {
      console.error("MFA code is empty.");
      alert("Please enter the MFA code.");
      return false;
    }
  }

  async verifyMfaAndDelete(mfaCode) {
    const isMfaConfirmed = await this.confirmMFACode(mfaCode);
    if (isMfaConfirmed) {
      console.log("MFA confirmed, proceeding with account deletion.");
      // 👇 Wait for export to complete
      await this.exportData();
      let deleteData = await this.zenplansDataService.deleteZenplansAccount();
      // let deleteData = true;
      console.log("deleteData - ", deleteData);
      if (deleteData && deleteData.success) {
        this.showStep2MFA = false;
        this.showStep3Deletion = true;
        // Start the countdown and logout
        this.logoutTimer = 10;
        this.logoutInterval = setInterval(() => {
          this.logoutTimer--;
          if (this.logoutTimer === 0) {
            clearInterval(this.logoutInterval);
          }
        }, 1000);

        setTimeout(() => {
          this.zenplansDataService.logout();
        }, 10000);
      } else {
        alert(
          "There was an issue deleting your account. Please try again later or contact our support."
        );
      }
    }
  }

  async resendMFA() {
    this.resendCodeDisabled = true;
    this.startCountdown();
    await this.zenplansDataService.requestMFACode();
    this.doMFA = true;
    alert("A code has been resent to your " + (this.isSMS ? "phone" : "email"));
  }

  startCountdown() {
    this.resendCodeDisabled = true;
    console.log(this.resendCodeDisabled);
    this.intervalId = setInterval(() => {
      this.counter--;

      if (this.counter <= 0) {
        this.stopCountdown();
        this.resendCodeDisabled = false;
      } else {
        this.resendCodeDisabled = true;
      }
    }, 1000);
  }

  stopCountdown() {
    clearInterval(this.intervalId);
    this.counter = 60;
  }

  updateIsClicked(val) {
    this.updateIsCheked = !val;
  }

  reminderIsClicked(val) {
    this.reminderIsCheked = !val;
  }

  openMobileMenu() {
    this.statusMobileMenu = !this.statusMobileMenu;
  }

  get f() {
    return this.aboutMeFormGroup.controls;
  }

  get g() {
    return this.passwordFormGroup.controls;
  }

  get h() {
    return this.itemOwnersFormGroup.controls;
  }

  async fileUpload(element) {
    this.dataIsLoaded = false;

    const result = await this.zenplansDataService.uploadFile(
      element.target.files[0],
      this.user.clientId,
      "logo"
    );

    this.dataIsLoaded = true;

    if (result.success) {
      // Update the avatar URL without reloading the page
      this.avatarUrl = await this.zenplansDataService.getAvatar(
        this.user.clientId
      );
    } else {
      this.message = "Sorry, your file could not be uploaded.";
    }
  }

  handleImageError(event: any) {
    console.error("Error loading image:", event);
  }

  callDialog(id, name) {
    this.itemToDeleteId = id;
    this.itemNameforDialog = name;
    this.showDialog = !this.showDialog;
  }
}

export interface IJointOwner {
  first: string;
  last: string;
  relationship: any;
}
